import { useEffect, useState } from "react";
import * as Sentry from "@sentry/browser";

import { getConfig } from "site-config";
import { fetchJSON } from "lib/fetch";

import { TAPIResponse } from "../types";
import { API_STATES, createAuthHeader } from "../helpers";

export type TRetailLocations = {
    data: {
        locations: {
            accountUUID: string;
            administrativeArea: string;
            countryCode: string;
            description: string;
            formatted: string;
            googlePlaceId: string;
            latitude: number;
            line1: string;
            line2: string;
            line3: string;
            locality: string;
            locationUUID: string;
            longitude: number;
            postalCode: string;
            title: string;
        }[];
    };
};

export const useRetailLocations = (): TAPIResponse<TRetailLocations, string> => {
    const { RSERIES_MARKETPLACE_LOCATION_MANAGER_URL } = getConfig();

    const [state, setState] = useState<TAPIResponse<TRetailLocations, string>>(API_STATES.default);

    const APIStates = API_STATES.getStates(setState);

    useEffect(() => {
        APIStates.pending();

        fetchJSON<TRetailLocations>(RSERIES_MARKETPLACE_LOCATION_MANAGER_URL, {
            method: "GET",
            headers: createAuthHeader(),
        })
            .then(APIStates.success)
            .catch((error) => {
                Sentry.captureMessage(error, {
                    level: "error",
                    tags: {
                        feature: "ExportOrderToPOS",
                        serviceName: "LocationManager",
                        source: "B2B",
                        statusCode: error.statusCode,
                    },
                });
                APIStates.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return state;
};
